import type {ReactNode} from 'react'
import {TableCell} from '@/components/ui/table'
import {cn} from '@/lib/utils'

interface TruncatedCellProps {
    children: ReactNode
    maxWidth?: string
    className?: string
    title?: string
    'data-testid'?: string
}

export function TruncatedCell({children, maxWidth = '300px', className, title, 'data-testid': testId}: TruncatedCellProps) {
    return (
        <TableCell
            className={cn('truncate', className)}
            style={{maxWidth}}
            title={title}
            data-testid={testId}
        >
            {children}
        </TableCell>
    )
}
